<template>
  <div :id="id" class="">
    <!-- /scatter area /-->
  </div>
</template>
<script>
import Echarts from 'echarts/lib/echarts.js';
import 'echarts/lib/chart/scatter.js';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';

export default {
    props: {
        code: {
            type: String,
            default: ''
        },
        target: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        score: {
            type: Number,
            default: 0
        },
        rate: {
            type: Number,
            default: 0
        },
        type: {
            type: Number,
            default: 1
        }
    },
    data: function() {
        return {
            id: `time-scatter-${Date.now()}-${Math.random()
                .toString(16)
                .replace('.', '')}`,
            scatter: null,
            is_mounted: false
        };
    },
    created: function() {
        const that = this;
        const timer = function() {
            if (that.is_mounted) {
                that.buildScatter();
            } else {
                setTimeout(timer, 100);
            }
        };
        timer();
    },
    mounted: function() {
        const that = this;
        that.is_mounted = true;
    },
    methods: {
        buildScatter: function() {
            let that = this;
            if (!that.scatter) {
                that.scatter = Echarts.init(document.querySelector(`#${that.id}`));
            }
            that.$http
                .get('/api/v1/evaluate_records/time_distribution', {
                    params: { code: that.code, tg: that.target, type: that.type }
                })
                .then(res => {
                    let bd = res.body;
                    if (bd.code === 0) {
                        let tmp = {};
                        let _count = Math.ceil(bd.result.reduce((pre, cur) => pre + cur[1], 0) * 0.85);
                        let _score = 0; // 标准分
                        let _index = 0; // 索引位置
                        bd.result.sort((a, b) => a[0] - b[0]);
                        bd.result.forEach(r => {
                            let t = r[0];
                            if (_index >= _count) {
                                t = _score + 2;
                            } else {
                                _index += r[1];
                                _score = t;
                            }
                            let td = tmp[t];
                            if (!td) {
                                td = [t, 0, '答题时间'];
                                tmp[t] = td;
                            }
                            td[1] = td[1] + r[1];
                        });
                        // console.log(that.name, _count, ',Score:', _score, ',Index:', _index);
                        let data1 = [];
                        for (let prop in tmp) {
                            data1.push(tmp[prop]);
                        }
                        let myTime = Math.ceil(that.score / 60000);
                        myTime = myTime >= _score + 2 ? _score + 2 : myTime;
                        var data = [
                            data1.map(curr => {
                                curr.push('答题时间');
                                return curr;
                            }),
                            [[myTime, tmp[myTime][1], '我的用时']]
                        ];
                        let options = {
                            title: {
                                show: 'true',
                                text: `答题时间分布`
                            },
                            legend: {
                                right: 10,
                                data: ['答题时间', '我的用时']
                            },
                            grid: {
                                left: '3%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: {
                                name: '（分）',
                                nameGap: 5,
                                splitLine: {
                                    lineStyle: {
                                        type: 'dashed'
                                    }
                                },
                                type: 'value'
                            },
                            yAxis: {
                                name: '(人数)',
                                type: 'value',
                                splitLine: {
                                    lineStyle: {
                                        type: 'dashed'
                                    }
                                }
                            },
                            series: [
                                {
                                    name: '答题时间',
                                    data: data[0],
                                    type: 'scatter',
                                    symbolSize: function(data) {
                                        return 6 * Math.sqrt(data[1]);
                                    },
                                    label: {
                                        emphasis: {
                                            show: true,
                                            formatter: function(param) {
                                                return `用时:${param.data[0] === 0 || param.data[0] === 180 ? (param.data[0] === 0 ? '0分' : '超过180分钟') : param.data[0] + '分'},${param.data[1]}人`;
                                            },
                                            position: 'top'
                                        },
                                        normal: {
                                            formatter: function(param) {
                                                return `用时:${param.data[0] === 0 || param.data[0] === 180 ? (param.data[0] === 0 ? '0分' : '超过180分钟') : param.data[0] + '分'},${param.data[1]}人`;
                                            }
                                        }
                                    },
                                    itemStyle: {
                                        normal: {
                                            color: '#fa444b'
                                        }
                                    }
                                },
                                {
                                    name: '我的用时',
                                    data: data[1],
                                    type: 'scatter',
                                    symbolSize: function(data) {
                                        return 4;
                                    },
                                    label: {
                                        normal: {
                                            show: true,
                                            formatter: function(param) {
                                                return '我';
                                            },
                                            position: 'top'
                                        }
                                    },
                                    itemStyle: {
                                        normal: {
                                            color: 'rgb(0, 165, 224)'
                                        }
                                    }
                                }
                            ]
                        };
                        that.scatter.setOption(options);
                    }
                });
        }
    },
    destroyed: function() {
        let that = this;
        if (that.scatter) {
            try {
                that.scatter.destroy();
            } catch (e) {}
        }
        if (that.tips) {
            try {
                that.tips.remove();
            } catch (e) {}
        }
    }
};
</script>
<style lang="less">
.time-scatter-tips {
    display: none;
    position: absolute;
    padding: 10px 10px 0;
    width: 200px;
    left: 0;
    top: 0;
    color: darken(rgb(251, 118, 123), 10%);
    border: 1px solid #333;
    background-color: rgba(40, 40, 40, 0.7);
    border-radius: 5px;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    z-index: 9999999;
    dl {
        margin: 0;
        padding: 0;
        dt {
            font-weight: 700;
        }
        dd {
            margin: 0;
            padding: 10px 0 10px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// time-scatter.vue?6f32c971